import moment from 'moment';
import subscriptionStateApi from '../../api/SubscriptionStateApi';
import billyApi from '../../api/BillyApi';

import { TRIAL_PERIODS, SUBSCRIPTION_STATES } from '../../constants/subscription-state';

const LOCAL_STORAGE_KEY = 'riseup.subscriptionCtaDismissedData';

const state = {
  subscriptionState: null,
  since: null,
  until: null,
  nextPaymentDate: null,
};

const getters = {
  daysLeft: state => Math.max(moment(state.until).diff(moment(), 'days') + 1, 0),
  trialLength: state => moment(state.until).diff(moment(state.since), 'days'),
  trialPeriod: (state, getters) => {
    if (getters.inTrial) {
      const diffWithUntil = moment(state.until).diff(moment(), 'days');
      if (diffWithUntil > 20) {
        return TRIAL_PERIODS.BEGINNING;
      } if (diffWithUntil <= 20 && diffWithUntil > 7) {
        return TRIAL_PERIODS.MIDDLE;
      }
      // 7 days left for the trial
      return TRIAL_PERIODS.FINAL;
    }
    return undefined;
  },
  inTrial: state => state.subscriptionState === SUBSCRIPTION_STATES.TRIAL,
  subscribed: state => state.subscriptionState === SUBSCRIPTION_STATES.SUBSCRIBED,
  shouldShowCta: (state, getters) => {
    if (getters.inTrial) {
      const subscriptionDismissedDataString = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (subscriptionDismissedDataString) {
        const { periodDismissed } = JSON.parse(subscriptionDismissedDataString);
        if (!periodDismissed) {
          return true;
        }
        const currentTrialPeriod = getters.trialPeriod;
        return currentTrialPeriod !== periodDismissed;
      }
      return true;
    }
    return false;
  },
};

const actions = {
  async initSubscriptionState({ dispatch }) {
    await dispatch('fetchSubscriptionState');
  },
  async fetchSubscriptionState({ commit }) {
    const subscriptionState = await subscriptionStateApi.fetchSubscriptionState();
    commit('setSubscriptionState', subscriptionState.state);
    commit('setSince', subscriptionState.since);
    commit('setUntil', subscriptionState.until);
    if (subscriptionState.state === SUBSCRIPTION_STATES.SUBSCRIBED) {
      try {
        const { subscription } = await billyApi.getSubscription();
        commit('setNextPaymentDate', subscription.nextPaymentDate);
      } catch (error) {
        commit('setNextPaymentDate', undefined);
      }
    }
  },
  ctaDismissed({ getters }) {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ dismissDate: new Date(), periodDismissed: getters.trialPeriod }));
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  setSubscriptionState(state, subscriptionState) {
    state.subscriptionState = subscriptionState;
  },
  setSince(state, since) {
    state.since = since;
  },
  setUntil(state, until) {
    state.until = until;
  },
  setNextPaymentDate(state, nextPaymentDate) {
    state.nextPaymentDate = nextPaymentDate;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
